<h1 mat-dialog-title class="corte-header">
  <span class="title">DETALLES DEL CORTE</span>
</h1>

<div mat-dialog-content class="corte-content">
  <div class="loading-overlay" *ngIf="isLoading">
    <mat-spinner diameter="48"></mat-spinner>
    <p>Cargando detalles del corte...</p>
  </div>
  
  <div class="corte-details" *ngIf="corteDetalles">
    <div class="corte-info">
      <div class="info-row">
        <div class="info-col">
          <span class="info-label">ID del Corte:</span>
          <span class="info-value">{{ corteDetalles.id }}</span>
        </div>
        <div class="info-col">
          <span class="info-label">Fecha de Creación:</span>
          <span class="info-value">{{ formatearFecha(corteDetalles.createdAt) }}</span>
        </div>
      </div>
      <div class="info-row">
        <div class="info-col">
          <span class="info-label">Proveedor:</span>
          <span class="info-value">{{ corteDetalles.proveedor?.nombre || 'N/A' }}</span>
        </div>
        <div class="info-col" style="display: flex; align-items: center; gap: 8px;">
          <span class="info-label">Estado:</span>
          <mat-chip [color]="getEstadoColor(corteDetalles.estado)" selected class="status-chip" style="margin: 0;">
            {{ corteDetalles.estado | titlecase }}
          </mat-chip>
        </div>
      </div>
      <div class="info-row">
        <div class="info-col">
          <span class="info-label">Fecha Inicio:</span>
          <span class="info-value">{{ formatearFecha(corteDetalles.fechaInicio) }}</span>
        </div>
        <div class="info-col">
          <span class="info-label">Fecha Fin:</span>
          <span class="info-value">{{ formatearFecha(corteDetalles.fechaFin) }}</span>
        </div>
      </div>
    </div>

    <div class="divider-line"></div>

    <div class="totals-section">
      <div class="total-row">
        <span class="total-label">Monto Total:</span>
        <span class="total-value">{{ formatearMoneda(corteDetalles.montoTotal) }}</span>
      </div>
      <div class="total-row">
        <span class="total-label">Monto Pagado:</span>
        <span class="total-value success">{{ formatearMoneda(corteDetalles.montoPagado) }}</span>
      </div>
      <div class="total-row grand-total">
        <span class="total-label">Saldo Pendiente:</span>
        <span class="total-value" [class.warning]="calcularSaldoPendiente() > 0">
          {{ formatearMoneda(calcularSaldoPendiente()) }}
        </span>
      </div>
    </div>

    <div class="divider-line"></div>

    <h3 class="products-title">DETALLES DEL CORTE</h3>
    <table mat-table [dataSource]="corteDetalles.detalles" class="products-table">
      <ng-container matColumnDef="producto">
        <th mat-header-cell *matHeaderCellDef class="table-header">PRODUCTO</th>
        <td mat-cell *matCellDef="let detalle" class="table-cell">
          {{ detalle.detalleVenta?.producto?.nombre || 'N/A' }}
          <div class="product-details" *ngIf="detalle.detalleVenta?.producto">
            <small>Código: {{ detalle.detalleVenta.producto.codigo }}</small>
            <small>Proveedor: {{ detalle.detalleVenta.producto.proveedorNombre || 'Sin proveedor' }}</small>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="venta">
        <th mat-header-cell *matHeaderCellDef class="table-header">VENTA</th>
        <td mat-cell *matCellDef="let detalle" class="table-cell">
          <div>ID: {{ detalle.detalleVenta?.venta?.id || 'N/A' }}</div>
          <small>Fecha: {{ detalle.detalleVenta?.venta?.fecha ? formatearFecha(detalle.detalleVenta.venta.fecha) : 'N/A' }}</small>
          <small>Vendedor: {{ detalle.detalleVenta?.venta?.usuario?.name || 'N/A' }}</small>
        </td>
      </ng-container>

      <ng-container matColumnDef="cantidad">
        <th mat-header-cell *matHeaderCellDef class="table-header text-center">CANT.</th>
        <td mat-cell *matCellDef="let detalle" class="table-cell text-center">
          {{ detalle.detalleVenta?.cantidad || 0 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="precio">
        <th mat-header-cell *matHeaderCellDef class="table-header text-right">P. UNITARIO</th>
        <td mat-cell *matCellDef="let detalle" class="table-cell text-right">
          {{ formatearMoneda(detalle.detalleVenta?.precioUnitario || 0) }}
        </td>
      </ng-container>

      <ng-container matColumnDef="monto">
        <th mat-header-cell *matHeaderCellDef class="table-header text-right">MONTO</th>
        <td mat-cell *matCellDef="let detalle" class="table-cell text-right">
          {{ formatearMoneda(detalle.monto) }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="['producto', 'venta', 'cantidad', 'precio', 'monto']" class="table-header-row"></tr>
      <tr mat-row *matRowDef="let row; columns: ['producto', 'venta', 'cantidad', 'precio', 'monto'];" class="table-row"></tr>
    </table>

    <div class="divider-line"></div>

    <div class="footer-message" *ngIf="corteDetalles.observaciones">
      <p><strong>Observaciones:</strong> {{ corteDetalles.observaciones }}</p>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end" class="corte-actions">
  <button mat-button (click)="onCancel()" class="action-button">Cerrar</button>
</div>

